import { createFileRoute } from "@tanstack/react-router";
import dayjs from "dayjs";
import { z } from "zod/v4";
import { zodValidator } from "@tanstack/zod-adapter";
import { PayinRouteComponent } from "./-components/payin/route";
import { getPayments } from "./-components/payin/api-requests";

const searchParams = z.object({
  from: z.string().optional(),
  to: z.string().optional(),
  paymentStatuses: z.string().optional(),
  currencies: z.string().optional(),
  page: z.number().optional().catch(1).default(1),
  rows: z.number().optional().catch(10).default(10),
  searchFilter: z.string().optional(),
  amountFrom: z.string().optional(),
  amountTo: z.string().optional(),
  paymentTypes: z.string().optional(),
  refundedFilter: z.string().optional(),
  heldFilter: z.string().optional(),
  riskCategory: z.string().optional(),
});

const defaultFrom = dayjs().subtract(30, "days").startOf("day").toISOString();
const defaultTo = dayjs().endOf("day").toISOString();

export const Route = createFileRoute(
  "/(app)/_main-layout/_payments/payments/payin",
)({
  component: () => <PayinRouteComponent />,
  validateSearch: zodValidator(searchParams),
  loaderDeps: ({
    search: {
      currencies,
      from,
      page,
      rows,
      searchFilter,
      paymentStatuses,
      to,
      amountFrom,
      amountTo,
      paymentTypes,
      refundedFilter,
      heldFilter,
      riskCategory,
      applicationId,
    },
  }) => ({
    currencies,
    from,
    page,
    paymentStatuses,
    rows,
    searchFilter,
    to,
    amountFrom,
    amountTo,
    paymentTypes,
    refundedFilter,
    heldFilter,
    riskCategory,
    applicationId,
  }),
  beforeLoad: ({ search, context }) => {
    // If first time loading, and default of GBP. Check if EUR and GBP are enabled then default to show both EUR and GBP
    if (search.currencies !== "GBP,EUR") {
      return;
    }
    // if (!context.selectedApplication.hasEUR) {
    //   throw redirect({
    //     to: location.pathname,
    //     search: (currentParams) => ({
    //       ...currentParams,
    //       currencies: "GBP",
    //     }),
    //   });
    // }
    // if (!context.selectedApplication.hasGBP) {
    //   throw redirect({
    //     to: location.pathname,
    //     search: (currentParams) => ({
    //       ...currentParams,
    //       currencies: "EUR",
    //     }),
    //   });
    // }
    return context;
  },
  loader: async ({ deps, context }) => {
    const defaultStartDateTime = deps.searchFilter
      ? undefined
      : (deps.from ?? defaultFrom);
    const defaultEndDateTime = deps.searchFilter
      ? undefined
      : (deps.to ?? defaultTo);
    const { success, data, error } = await getPayments({
      accessToken: context.accessToken,
      applicationId: context.selectedApplicationId,
      params: {
        paymentStatuses: deps.paymentStatuses,
        startDateTimeUtc: defaultStartDateTime,
        endDateTimeUtc: defaultEndDateTime,
        currencies: deps.currencies,
        page: (deps.page - 1).toString(),
        size: deps.rows.toString(),
        sort: "createdAt,desc",
        merchantId: context.merchantId,
        paymentTypes: deps.paymentTypes,
        refundedFilter: deps.refundedFilter,
        heldFilter: deps.heldFilter,
        riskCategory: deps.riskCategory,
        amountFrom: deps.amountFrom ? Number(deps.amountFrom) : undefined,
        amountTo: deps.amountTo ? Number(deps.amountTo) : undefined,
        globalSearch: deps.searchFilter,
      },
    });
    if (!success) {
      console.error(
        "Failed to fetch payments, API response did not parse correctly",
        error,
      );

      throw new Error("Failed to fetch payments");
    }
    return data;
  },
});
